import React from 'react';
import { Button, Modal, Input, Row, Divider } from 'antd';
import PropTypes from 'prop-types';
import ShareIcon from 'components/Icons/ShareIcon';
import CopyIcon from 'components/Icons/CopyIcon';
import PublishedWhatsappIcon from 'components/Icons/PublishedWhatsappIcon';
import PublishedDownloadIcon from 'components/Icons/PublishedDownloadIcon';
import CloseIcon from 'components/Icons/CloseIcon';

import './PublishedProposalModal.scss';
import { EmailSettingsSection } from './EmailSettingsSection';
import { ScheduleIcon } from 'components/Icons';
import PageHeader from 'components/PageHeader';

const PublishedProposalModal = ({
  onCancel,
  publishedProposalLink,
  copyPropsalLink,
  downloadPdf,
  proposal,
  onSettingUpdate,
  setInternalProp,
  fromDashboard = false,
}) => {
  const pdfLink = publishedProposalLink();

  return (
    <Modal
      className="published-proposal-modal"
      centered
      visible
      footer={null}
      style={{ maxWidth: '604px' }}
      width={'100%'}
      closeIcon={<CloseIcon />}
      onCancel={onCancel}>
      <div>{proposal.isScheduled ? <ScheduleIcon /> : <ShareIcon />}</div>
      {proposal.isScheduled ? (
        <PageHeader pageTitle="Your Proposal Is Scheduled For" />
      ) : (
        <>
          {' '}
          <h3 className="title">
            {proposal.sharedViaMail
              ? 'Your proposal has been sent.'
              : fromDashboard
              ? 'Your proposal is live.'
              : 'Great job! Your Proposal is now live.'}
          </h3>
          <div className="divider" />
          <p className="body">You can share this link below with your client.</p>
        </>
      )}
      {!proposal.isScheduled && (
        <>
          <Row className="input-with-copy-btn">
            <Input
              id="pdf-link-input"
              name="pdf-link-input"
              type="text"
              className="pdf-link-input"
              value={pdfLink}
              readOnly
            />
            <Button
              icon={<CopyIcon />}
              className="copy-btn medium-btn secondary-btn"
              onClick={copyPropsalLink}>
              COPY
            </Button>
          </Row>
          <div className="email-modal-options-block">
            <div
              onClick={() =>
                window.open(`https://web.whatsapp.com/send?text=${pdfLink}`, '_blank')
              }>
              <PublishedWhatsappIcon />
              <span className="helper-text">Send Via WhatsApp</span>
            </div>
            <div onClick={downloadPdf}>
              <PublishedDownloadIcon />
              <span className="helper-text">Download .PDF</span>
            </div>
          </div>
          <Divider>OR SEND VIA:</Divider>
        </>
      )}
      <EmailSettingsSection
        onClose={onCancel}
        proposal={proposal}
        onSettingUpdate={onSettingUpdate}
        setInternalProp={setInternalProp}
      />
    </Modal>
  );
};

PublishedProposalModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  publishedProposalLink: PropTypes.func.isRequired,
  copyPropsalLink: PropTypes.func.isRequired,
  downloadPdf: PropTypes.func.isRequired,
};

export default PublishedProposalModal;
